import React from 'react';
import { motion } from 'framer-motion';
import { CpuIcon, SmartphoneIcon, Link2Icon, FingerprintIcon } from 'lucide-react';
const solutions = [{
  icon: <CpuIcon className="w-5 h-5 md:w-6 md:h-6 text-brand-cyan" data-id="element-558" />,
  title: 'Smart & Connected',
  description: 'Your smart t-shirt comes alive with embedded NFC. Every tap opens a dynamic digital experience — never static again.'
}, {
  icon: <SmartphoneIcon className="w-5 h-5 md:w-6 md:h-6 text-brand-cyan" data-id="element-559" />,
  title: 'Invisible NFC Tap',
  description: 'No ugly QR codes. No scanning. Just tap your phone to the t-shirt — clean design, seamless technology.'
}, {
  icon: <Link2Icon className="w-5 h-5 md:w-6 md:h-6 text-brand-cyan" data-id="element-560" />,
  title: 'Always Linked',
  description: 'Your socials, profile, and contact info live in your smart t-shirt. One tap shares everything — nothing gets lost.'
}, {
  icon: <FingerprintIcon className="w-5 h-5 md:w-6 md:h-6 text-brand-cyan" data-id="element-561" />,
  title: 'Your Unique Identity',
  description: 'Your smart t-shirt becomes uniquely yours. A dynamic digital profile that updates and evolves with you.'
}];
export function SolutionSection() {
  return <section id="features" className="py-10 md:py-20 bg-brand-darkest relative overflow-hidden" data-id="element-562">
      {/* Glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-cyan/5 rounded-full blur-[100px] pointer-events-none" data-id="element-563"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-564">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-565">
          <span className="text-brand-cyan font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 block" data-id="element-566">
            The Solution
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-bold mb-3 md:mb-6" data-id="element-567">
            2.0 QTap Smart T-Shirt
          </h2>
          <p className="text-gray-400 text-sm md:text-lg" data-id="element-568">
            Every problem solved. Your smart t-shirt becomes a living, connected
            gateway.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-569">
          {solutions.map((solution, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-card p-4 md:p-8 border-brand-cyan/20 hover:border-brand-cyan/40 transition-colors group flex flex-col h-full" data-id="element-570">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl bg-brand-cyan/10 flex items-center justify-center mb-3 md:mb-6 group-hover:scale-110 transition-transform" data-id="element-571">
                {solution.icon}
              </div>
              <h3 className="text-sm sm:text-base md:text-xl font-bold mb-1.5 md:mb-3 font-heading" data-id="element-572">
                {solution.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-xs md:text-sm flex-grow" data-id="element-573">
                {solution.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}